import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "menu-goEarly-reconciliation-icon",
  "use": "menu-goEarly-reconciliation-icon-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"menu-goEarly-reconciliation-icon\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M13 1H1V6H5.5V15H15V3H13V1ZM2 5V2H12V3H5.5V5H2ZM14 14H6.5V4H14V14ZM8.5 5.5H7.5V6.5H8.5V5.5ZM9.5 5.5H13V6.5H9.5V5.5ZM8.5 8.5H7.5V9.5H8.5V8.5ZM9.5 8.5H13V9.5H9.5V8.5ZM8.5 11.5H7.5V12.5H8.5V11.5ZM9.5 11.5H13V12.5H9.5V11.5Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol